import { ReturnHistory } from 'types';
import { Text } from 'components/text';
import { formatReturnHistoryValue } from 'helpers';
import { FontSize, FontWeight } from 'commons';
import { HistoryCheck } from '../history-check';

interface Props {
  entry: ReturnHistory;
  isLast: boolean;
  isDone: boolean;
}

export function ReturnHistoryContent({ entry, isLast, isDone }: Props) {
  const content = formatReturnHistoryValue(entry);

  return (
    <>
      <Text
        size={FontSize.font12}
        weight={isDone || isLast ? FontWeight.bold : FontWeight.regular}
      >
        {content}
      </Text>

      {isDone && <HistoryCheck />}
    </>
  );
}
